import React, { useState } from 'react'
import _ from 'lodash'
import Controls from '../../controls/Controls';
import getDataFromCube from '../../../utils/getCubeData';

export default function FilterSelectValue({ i, reportDetails, updateReportDetails, filterCondtion }) {
    let { operator } = filterCondtion
    const [filter, setFilter] = useState((operator === 'top' || operator === 'bottom' ? (filterCondtion?.limit ?? null) : filterCondtion?.values?.map(value => value).filter(value=>value!="").join('\n') ?? null));

    const getFilterCubeData = (filter) => {
        return getDataFromCube(undefined, undefined, undefined, "limitReportFiter", { filter, reportDetails });
    }

    let onChangeFilterValue = async (e, i) => {
        setFilter(e.target.value);
        let filterCondtionCloned = _.cloneDeep(filterCondtion)
        
        let values = e.target.value
          ? e.target.value?.split("\n").filter((value) => value != "")
          : [];

        if (filterCondtionCloned?.operator === "top" || filterCondtionCloned?.operator === "bottom") {
            if (values?.length > 0 && values[0] !=='')
                filterCondtionCloned.limit = values[0];
            else
                delete filterCondtionCloned?.limit


            let valArr = []
            const values = await getFilterCubeData(filterCondtionCloned)
            if (values.length) {
                valArr = values.map(ele => {
                    if (typeof ele === 'object') {
                        return ele[filterCondtionCloned?.member]
                    }
                    else {
                        return ele
                    }
                })
            }

            reportDetails.reportDetails.reportFilters[i].values = valArr?.length ? valArr : [];

            if (values?.length > 0 && values[0] !== '') {
                reportDetails.reportDetails.reportFilters[i].limit = values[0];
            }
            else {
                delete reportDetails?.reportDetails?.reportFilters?.[i]?.limit
            }

            updateReportDetails({ reportDetails: reportDetails.reportDetails });
        }
        else {
            reportDetails.reportDetails.reportFilters[i].values =
              values.length > 0 ? values : [];
            updateReportDetails({ reportDetails: reportDetails.reportDetails });
        }
    }

    return (
        <>
            <Controls.Input
                value={filter}
                className="report_form_ui_input" placeholder='Enter Value...' onChange={e => onChangeFilterValue(e, i)} 
                multiline= {!(filterCondtion?.operator === 'top' || filterCondtion?.operator === 'bottom')}
                maxRows={4}
                style= {{backgroundColor: 'white'}}
                size="small"
                />
        </>
    )
}
